/* tslint:disable:no-var-requires */
const store = require('store')

import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Master from './views/Master.vue'

import Surveys from './views/app/Surveys.vue'
import Inbox from './views/app/Inbox.vue'
import Profile from './views/app/Profile.vue'
import Task from './views/app/Task.vue'
import TaskHome from './views/app/TaskHome.vue'
import Rooms from './views/app/Rooms.vue'
import Items from './views/app/Items.vue'
import Services from './views/app/Services.vue'
import Summary from './views/app/Summary.vue'
import Attention from './views/app/Attention.vue'
import Done from './views/app/Done.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Master,
      children: [
        {
          path: '/',
          name: 'home',
          component: Surveys,
        },
        {
          path: '/attention',
          name: 'attention',
          component: Attention,
        },
        {
          path: '/done',
          name: 'done',
          component: Done,
        },
        {
          path: '/survey/:id',
          component: Task,
          children: [
            {
              path: 'rooms',
              name: 'rooms',
              component: Rooms,
            },
            {
              path: 'rooms/:roomId/items',
              name: 'items',
              component: Items,
            },
            {
              path: 'services',
              name: 'services',
              component: Services,
            },
            {
              path: 'summary',
              name: 'summary',
              component: Summary,
            },
            {
              path: '',
              name: 'survey',
              component: TaskHome,
            },
          ],
        },
        {
          path: '/inbox',
          name: 'inbox',
          component: Inbox,
        },
        {
          path: '/profile',
          name: 'profile',
          component: Profile,
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
  ],
  linkActiveClass: 'is-active',
})

router.beforeEach((to, from, next) => {
  const user = store.get('user')

  if (!user) {
    if (to.name !== 'login') {
      return next({name: 'login'})
    }
    return next()
  } else {
    if (to.name === 'login') {
      return next({name: 'home'})
    }
    return next()
  }
})

export default router
